export const QUALITY_MANAGEMENT = '/qualityManagement';
